import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const Spinner = ({ ...props }) => <CircularProgress {...props} />;

export default Spinner;
